
import { defineComponent, PropType, ref, VNode, watch } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import { StoryPoster } from '@/types';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    to: {
      type: Object as PropType<RouteLocationRaw>,
      required: true,
    },
    hero: {
      type: Object as PropType<StoryPoster>,
      required: true,
    },
    titleTop: {
      type: String,
      required: true,
    },
    titleBottom: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['activate', 'animated'],
  setup(props, { emit }) {
    const date = new Date(props.date);
    const dateStr = `${date.toLocaleString('en-GB', {
      month: 'long',
    })} ${date.getFullYear()}`;

    const rootEl = ref<VNode | null>(null);
    const onClick = (e: Event) => {
      e.preventDefault();
      if (rootEl.value) {
        emit('activate', rootEl.value);
      }
    };

    const onActivate = () => {
      setTimeout(() => {
        emit('animated');
      }, 700);
    };
    watch(() => props.active, onActivate);

    return {
      dateStr,
      onClick,
      rootEl,
    };
  },
});
